const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org-id/$orgId/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { orgIdSplatBeforeLoad } from './-splat';
export const Route = createFileRoute('/(app)/org-id/$orgId/$')({
  beforeLoad: orgIdSplatBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});